import React, { Component } from 'react';
import { connect } from 'react-redux';
import Node from '../nodes/Node'
import { setInitialPosition } from '../../actions';

export class Login extends Component {
  componentWillMount() {
    this.props.setInitialPosition(window.innerHeight, window.innerWidth, 'l')
  };

  render() {
    return (
      <div>
        <Node id={'login'} number='l' parent='l' root={true} page={0} />
      </div>
    )
  }

}

const mapStateToProps = state => ({
  client: state.client
});

const mapDispatchToProps = {
  setInitialPosition
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/SignupLogin/Login.js